import { Theme } from "@mui/material"

export const commonRoutes = {
    home: "/",
    landing: "/landing",
    login: "/"
}

export const graphUrls = {
    photo: "https://graph.microsoft.com/v1.0/me/photo/$value"
}

export const autoRefreshTopics = {
    winMarket: "win-market",
    derivMarket: "derivative-market"
}

export const commonColours = (theme: Theme) => {
    return {
        suspended: theme.palette.error.main,
        suspendedBackground: "rgb(255,217,217)",
        suspendedHeaderBackground: "rgb(245,207,207)",
        displayOnly: "purple",
        distributed: theme.palette.success.main,
        firstColumnBackground: "rgb(207,228,255)"
    }
}

export const eventStatusCodes = {
    On: "O",
    Void: "V",
    Abandon: "A"
}

export const eventStatusDesc = (eventStatusCode: string) => {
    switch (eventStatusCode) {
        case eventStatusCodes.On: return "On";
        case eventStatusCodes.Void: return "Voided";
        case eventStatusCodes.Abandon: return "Abandoned";
        default: return "";
    }
}

export const eventProgressCodes = {
    Off: "O"
}

export const timezones = {
    UK: "Europe/London"
}
